import { ReactNode } from "react";

export type EmptyStateProps = {
  // Single-line headline ("No workspaces yet"). Required so every empty
  // surface in the app makes a clear claim about what's missing.
  title: string;
  // One-or-two-sentence guidance: what the page expects and how to populate
  // it. Keep concrete — point at the path the operator should take.
  description?: ReactNode;
  // Optional decorative glyph rendered above the title. Pass an emoji,
  // svg-as-text, or a small node. Decorative only — set aria-hidden.
  icon?: ReactNode;
  // Primary + secondary calls-to-action (e.g. "Create package", "Read docs").
  actions?: ReactNode;
  // For test selection.
  "data-testid"?: string;
};

export default function EmptyState({
  title,
  description,
  icon,
  actions,
  "data-testid": testId
}: EmptyStateProps) {
  return (
    <div className="empty-state" role="status" data-testid={testId}>
      {icon && (
        <span className="empty-state__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <h3 className="empty-state__title">{title}</h3>
      {description && <p className="empty-state__body">{description}</p>}
      {actions && <div className="empty-state__actions">{actions}</div>}
    </div>
  );
}
